import { createTheme } from '@mui/material/styles'

export const adminTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#C9A227',
      light: '#E8D5A3',
      dark: '#9A7B1A',
      contrastText: '#0c0f14',
    },
    secondary: {
      main: '#1a2332',
      light: '#2d3a4f',
      dark: '#0c0f14',
      contrastText: '#faf8f5',
    },
    success: { main: '#2d9d78' },
    warning: { main: '#e8a838' },
    error: { main: '#d64545' },
    background: {
      default: '#f4f1eb',
      paper: '#ffffff',
    },
    text: {
      primary: '#141820',
      secondary: '#5c6478',
    },
  },
  typography: {
    fontFamily: '"Montserrat", "DM Sans", system-ui, sans-serif',
    h1: { fontWeight: 700, letterSpacing: '-0.03em' },
    h2: { fontWeight: 700, letterSpacing: '-0.02em' },
    h3: { fontWeight: 600, letterSpacing: '-0.02em' },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600, letterSpacing: '0.02em' },
  },
  shape: { borderRadius: 16 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: '10px 20px',
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #D4A657 0%, #B8892E 100%)',
          color: '#0c0f14',
          '&:hover': {
            background: 'linear-gradient(135deg, #E8C06A 0%, #C9A227 100%)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            backgroundColor: 'rgba(255,255,255,0.9)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
})
